import { STATE_LOGIN, STATE_VERIFY } from './components/AuthForm';
import GAListener from './components/GAListener';
import { EmptyLayout, LayoutRoute, MainLayout } from './components/Layout';
import PageSpinner from './components/PageSpinner';
import AuthPage from '././pages/AuthPage';
import React from 'react';
import componentQueries from 'react-component-queries';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import './styles/reduction.scss';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';

const AuthModalPage = React.lazy(() => import('./pages/AuthModalPage'));
const DashboardPage = React.lazy(() => import('./pages/DashboardPage'));
const ListUser = React.lazy(() => import('./pages/user/ListUser'));
const OnlineUser = React.lazy(() => import('./pages/user/OnlineUser'));
const NewUser = React.lazy(() => import('./pages/user/NewUser'));
const ListCompany = React.lazy(() => import('./pages/company/ListCompany'));
const NewCompany = React.lazy(() => import('./pages/company/NewCompany'));
const NewTemplate = React.lazy(() =>
  import('./pages/database/template/NewTemplate'),
);
const UserCompanyAccess = React.lazy(() =>
  import('./pages/company/UserCompanyAccess'),
);
const UserCompanyAlert = React.lazy(() =>
  import('./pages/company/UserCompanyAlert'),
);
const ListTicket = React.lazy(() => import('./pages/ticket/ListTicket'));
const TicketDetails = React.lazy(() => import('./pages/ticket/TicketDetails'));
const ListSensorData = React.lazy(() =>
  import('./pages/sensor/ListSensorData'),
);
const ListVersion = React.lazy(() => import('./pages/device/ListVersion'));
const ListMilligradeBoard = React.lazy(() =>
  import('./pages/device/milligrade/ListBoard'),
);
const ListTemplate = React.lazy(() =>
  import('./pages/database/template/ListTemplate'),
);
const ListDatabase = React.lazy(() => import('./pages/database/ListDatabase'));
const ListPost = React.lazy(() => import('./pages/post/ListPost'));
const NewPost = React.lazy(() => import('./pages/post/NewPost'));
const NewFile = React.lazy(() => import('./pages/post/file/NewFile'));
const ListComment = React.lazy(() =>
  import('./pages/post/comment/ListComment'),
);
const ListBanner = React.lazy(() => import('./pages/banner/ListBanner'));
const NewBanner = React.lazy(() => import('./pages/banner/NewBanner'));
const ListMatnaBanner = React.lazy(() =>
  import('./pages/banner/ListMatnaBanner'),
);
const NewMatnaBanner = React.lazy(() =>
  import('./pages/banner/NewMatnaBanner'),
);
const ListAnnounce = React.lazy(() => import('./pages/announce/ListAnnounce'));
const NewAnnounce = React.lazy(() => import('./pages/announce/NewAnnounce'));
const ListCatalogue = React.lazy(() =>
  import('./pages/catalogue/ListCatalogue'),
);
const NewCatalogue = React.lazy(() => import('./pages/catalogue/NewCatalogue'));
const ListContact = React.lazy(() => import('./pages/contact/ListContact'));
const ListJoinUs = React.lazy(() => import('./pages/join/JoinUs'));
const ListAlert = React.lazy(() => import('./pages/alert/ListAlert'));

class App extends React.Component {
  render() {
    if (
      process.env.REACT_APP_EXPIRE_TIME &&
      new Date(process.env.REACT_APP_EXPIRE_TIME) < new Date()
    ) {
      return <div>مهلت دسترسی به اپلیکیشن به اتمام رسیده است.</div>;
    }

    return (
      <BrowserRouter
        basename={process.env.REACT_APP_SUB_PATH ?? '/backoffice/'}
      >
        <GAListener>
          <Switch>
            <LayoutRoute
              exact
              path="/login"
              layout={EmptyLayout}
              component={props => (
                <AuthPage {...props} authState={STATE_LOGIN} />
              )}
            />
            <LayoutRoute
              exact
              path="/signup"
              layout={EmptyLayout}
              component={props => (
                <AuthPage {...props} authState={STATE_VERIFY} />
              )}
            />
            <MainLayout breakpoint={this.props.breakpoint}>
              <React.Suspense fallback={<PageSpinner />}>
                <Route exact path="/" component={DashboardPage} />
                <Route exact path="/login-modal" component={AuthModalPage} />
                <Route exact path="/users" component={ListUser} />
                <Route exact path="/online-users" component={OnlineUser} />
                <Route exact path="/users/new" component={NewUser} />
                <Route exact path="/companies" component={ListCompany} />
                <Route exact path="/companies/new" component={NewCompany} />
                <Route
                  exact
                  path="/database/templates/new"
                  component={NewTemplate}
                />
                <Route
                  exact
                  path="/user-company-access"
                  component={UserCompanyAccess}
                />
                <Route
                  exact
                  path="/user-company-alert"
                  component={UserCompanyAlert}
                />
                <Route exact path="/tickets" component={ListTicket} />
                <Route exact path="/ticket-details" component={TicketDetails} />
                <Route exact path="/sensors-data" component={ListSensorData} />
                <Route exact path="/versions" component={ListVersion} />
                <Route
                  exact
                  path="/milligrade"
                  component={ListMilligradeBoard}
                />
                <Route
                  exact
                  path="/database/templates"
                  component={ListTemplate}
                />
                <Route
                  exact
                  path="/database-reports"
                  component={ListDatabase}
                />
                <Route exact path="/posts" component={ListPost} />
                <Route exact path="/posts/new" component={NewPost} />
                <Route exact path="/files/new" component={NewFile} />
                <Route exact path="/comments" component={ListComment} />
                <Route exact path="/banners" component={ListBanner} />
                <Route exact path="/matna-banner" component={ListMatnaBanner} />
                <Route exact path="/banners/new" component={NewBanner} />
                <Route
                  exact
                  path="/matna-banner/new"
                  component={NewMatnaBanner}
                />
                <Route exact path="/announces" component={ListAnnounce} />
                <Route exact path="/announce/new" component={NewAnnounce} />
                <Route exact path="/catalogues" component={ListCatalogue} />
                <Route exact path="/catalogues/new" component={NewCatalogue} />
                <Route exact path="/alerts" component={ListAlert} />
                <Route exact path="/contacts" component={ListContact} />
                <Route exact path="/join-us" component={ListJoinUs} />
              </React.Suspense>
            </MainLayout>
            <Redirect to="/" />
          </Switch>
        </GAListener>
      </BrowserRouter>
    );
  }
}

const query = ({ width }) => {
  if (width < 575) {
    return { breakpoint: 'xs' };
  }

  if (576 < width && width < 767) {
    return { breakpoint: 'sm' };
  }

  if (768 < width && width < 991) {
    return { breakpoint: 'md' };
  }

  if (992 < width && width < 1199) {
    return { breakpoint: 'lg' };
  }

  if (width > 1200) {
    return { breakpoint: 'xl' };
  }

  return { breakpoint: 'xs' };
};

export default componentQueries(query)(App);
